<template>
    <component :is="tag" style="height: 100%">
        <slot
            :brief="brief"
            :contact="contact"
            :task="task"
            :deliverable="deliverable"
            :is-loading="isLoading"
            :error-message="errorMessage"
            :deliver-story-url="deliverStoryUrl"
            :deliver-insights-url="deliverInsightsUrl"
            :upload-headers="uploadHeaders"
            :is-deliverable-complete="isDeliverableComplete"
            :deliverable-has-insights="deliverableHasInsights"
            :handle-story-file-change="handleStoryFileChange"
            :handle-insights-file-change="handleInsightsFileChange"
            :handle-start-connection="handleStartConnection"
            :handle-error="handleError"
        />
    </component>
</template>

<script>
    import ContactsMixin from '../mixins/ContactsMixin';
    import UploadMixin from '../mixins/UploadMixin';
    import BaseActivationBriefStepMixin from '../mixins/BaseActivationBriefStepMixin';
    import ActivationBriefNetworkConnectionSourceMixin from '../mixins/ActivationBriefNetworkConnectionSourceMixin';
    import * as _ from 'lodash';
    import { message } from '@grininc/grin-ui';
    import ActivationBriefTasksMixin from '../mixins/ActivationBriefTasksMixin';
    import { NAME_TASKS } from '../../../constants/activation-brief-steps';

    export default {
        name: 'ActivationTaskCustomDeliveryProvider',
        mixins: [
            ContactsMixin,
            BaseActivationBriefStepMixin,
            UploadMixin,
            ActivationBriefNetworkConnectionSourceMixin,
            ActivationBriefTasksMixin
        ],
        computed: {
            step() {
                return this.steps[NAME_TASKS];
            },
            taskId() {
                return _.get(this, 'task.id');
            },
            deliverableId() {
                return _.get(this, 'deliverable.id');
            },
            contactId() {
                return _.get(this, 'contact.id');
            },
            deliverStoryUrl() {
                if (this.taskRequiresApproval && this.deliverableParamId) {
                    return `/activation-briefs/${this.briefParamId}/deliverables/${this.deliverableParamId}/deliver/story`;
                }
                return `/activation-briefs/${this.briefParamId}/tasks/${this.taskId}/deliver/story`;
            },
            deliverInsightsUrl() {
                return `/activation-briefs/${this.briefParamId}/tasks/${this.taskId}/deliver/story/insights`;
            }
        },
        methods: {
            handleStoryFileChange(info) {
                this.handleUploadChange(info, (info) => {
                    this.loadActivationBrief(true).then(() =>
                        message.success('Nice! Your sponsorship task has been delivered')
                    );
                });
            },
            handleInsightsFileChange(info) {
                this.handleUploadChange(info, (info) => {
                    this.loadActivationBrief(true).then(() =>
                        message.success('The story insights screenshot has been uploaded')
                    );
                });
            },
            handleError(error) {
                this.handleHttpError(error, 'delivery');
            }
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([this.loadActivationBrief(true)]);
                })
                .then(() => {
                    this.initStep(this.step);
                })
                .catch((error) => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        }
    };
</script>
